import { Icon } from '@chakra-ui/react';

export default function SFPlayFilled(props) {
  return (
    <Icon
      width='13px'
      height='14px'
      viewBox='0 0 13 14'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M1.92188 13.9844C1.34375 13.9844 0.984375 13.5391 0.984375 12.8594V1.875C0.984375 1.19531 1.34375 0.757812 1.92188 0.757812C2.23438 0.757812 2.5 0.875 2.8125 1.05469L11.9219 6.32812C12.5703 6.70312 12.7969 6.95312 12.7969 7.36719C12.7969 7.78125 12.5703 8.03125 11.9219 8.41406L2.8125 13.6797C2.5 13.8594 2.23438 13.9844 1.92188 13.9844Z' />
    </Icon>
  );
}
